import { render, staticRenderFns } from "./GlasgowComaScore.vue?vue&type=template&id=18541c4a&scoped=true&"
import script from "./GlasgowComaScore.vue?vue&type=script&lang=js&"
export * from "./GlasgowComaScore.vue?vue&type=script&lang=js&"
import style0 from "./GlasgowComaScore.vue?vue&type=style&index=0&id=18541c4a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18541c4a",
  null
  
)

export default component.exports